import CrmStatus from '@/components/Table/CrmStatus'
import type { GridRenderCellParams } from '@mui/x-data-grid'
import { CustomColumnGridConfig } from '../types'
import dayjs from 'dayjs'
import { renderAlertWithMutedIndication } from '@/utils/mutedAlertRenderer'
import NotificationChannelStatuses from '@/components/notification-send/NotificationChannelStatuses'
import NotificationStatusChip from '@/components/notification-send/NotificationStatusChip'

export const CONSUMPTION_FIELD = 'consumption' as const

// The grid is 546 px wide at 1024 x 768. Five columns of 104 px and the sent column of 127 px
// fit it, so "sent" needs no sideways scroll. Each title stays whole because the grid puts the
// header buttons on a second line (twoLineHeaders), and fit-to-header would only widen the
// columns again.
const TITLED_MIN_WIDTH = 104

const columnsConfig: CustomColumnGridConfig[] = [
  {
    flex: 1,
    minWidth: TITLED_MIN_WIDTH,
    fitHeader: false,
    field: 'warningCode',
    headerName: 'קוד התראה',
    hideable: true,
    disableAggregation: true,
    filter: {
      type: 'options',
    },
    filterable: true,
  },
  {
    flex: 1,
    minWidth: TITLED_MIN_WIDTH,
    fitHeader: false,
    field: 'alertCode',
    headerName: 'התראה',
    hideable: true,
    disableAggregation: true,
    filter: {
      type: 'options',
    },
    filterable: true,
    renderCell: (params: any) => renderAlertWithMutedIndication(params.row.alertCode ?? '-', params.row),
  },
  {
    flex: 1,
    minWidth: TITLED_MIN_WIDTH,
    fitHeader: false,
    field: 'opening',
    headerName: 'ת.פתיחה',
    hideable: true,
    disableAggregation: true,
    filter: {
      type: 'options',
    },
    filterable: true,
    renderCell: (params: any) => {
      return params.value ? dayjs(params.value).format('DD/MM/YYYY') : '-'
    },
  },
  {
    flex: 1,
    minWidth: TITLED_MIN_WIDTH,
    fitHeader: false,
    field: 'closing',
    headerName: 'ת.סגירה',
    hideable: true,
    disableAggregation: true,
    filter: {
      type: 'options',
    },
    filterable: true,
    renderCell: (params: any) => {
      return params.value ? dayjs(params.value).format('DD/MM/YYYY') : '-'
    },
  },
  {
    flex: 1,
    // One channel with the longest status and a count; more channels wrap.
    minWidth: 127,
    field: 'sent',
    headerName: 'נשלח',
    filter: {
      type: 'none',
    },
    renderCell: ({ row }: GridRenderCellParams) => (
      <NotificationChannelStatuses channels={row.channels ?? []} />
    ),
  },
  {
    flex: 1,
    minWidth: TITLED_MIN_WIDTH,
    fitHeader: false,
    field: 'status',
    headerName: 'סטטוס',
    hideable: true,
    disableAggregation: true,
    filter: {
      type: 'options',
    },
    filterable: true,
    renderCell: ({ value }: GridRenderCellParams) =>
      value ? <NotificationStatusChip status={value} /> : '-',
  },
  {
    flex: 1,
    minWidth: TITLED_MIN_WIDTH,
    fitHeader: false,
    field: 'crm',
    headerName: 'crm',
    renderCell: (params: any) => {
      return params.value ? <CrmStatus value={params.value} /> : '-'
    },
    filter: {
      type: 'options',
    },
    hideable: true,
    disableAggregation: true,
    filterable: true,
  },
]

export default columnsConfig
